import DashboardPage from 'modules/authentication/components/DashboardPage';

import ManageClientsPage from 'modules/authentication/components/ManageClientsPage';
import IndexUploadPackets from 'modules/authentication/components/UploadPage';
import ManagePacketPage from 'modules/home/manage-packets/listing-packets/ManagePacketsPage';
import ManageAccessPage from 'modules/authentication/components/ManageAccessPage';

// const FAQPage = lazy(() => import('modules/authentication/components/FAQPage'));
/**
 * Main route configuration.
 * @returns {Object} The main route object.
 */
const MainRoute = (): any => [
    {
        /**
         * The path for the dashboard route.
         * @type {string}
         */
        path: 'dashboard',

        /**
         * The element to be rendered for the dashboard route.
         * @type {ReactElement}
         */
        element: <DashboardPage />,
    },
    {
        /**
         * The path for the upload packets route.
         * @type {string}
         */
        path: 'upload-cross-checks',

        /**
         * The element to be rendered for the upload packets route.
         * @type {ReactElement}
         */
        element: <IndexUploadPackets />,
    },
    {
        /**
         * The path for the manage packets route.
         * @type {string}
         */
        path: 'manage-cross-checks',

        /**
         * The element to be rendered for the manage packets route.
         * @type {ReactElement}
         */
        element: <ManagePacketPage />,
    },
    {
        /**
         * The path for the manage clients route.
         * @type {string}
         */
        path: 'manage-checklists',

        /**
         * The element to be rendered for the manage clients route.
         * @type {ReactElement}
         */
        element: <ManageClientsPage />,
        children: [{ path: 'add' }, { path: 'edit/:clientId' }],
    },
    {
        /**
         * The path for the manage access route.
         * @type {string}
         */
        path: 'manage-access',

        /**
         * The element to be rendered for the manage clients route.
         * @type {ReactElement}
         */
        element: <ManageAccessPage />,
    },
    // {
    //     /**
    //      * The path for the manage access route.
    //      * @type {string}
    //      */
    //     path: 'faq',

    //     /**
    //      * The element to be rendered for the manage clients route.
    //      * @type {ReactElement}
    //      */
    //     element: <FAQPage />,
    // },
];

export default MainRoute;
